module.exports = __webpack_public_path__ + "static/img/moduloRele2-1.aae6763.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/moduloRele2-1.svg
// module id = K+o3
// module chunks = 0